module.exports = __webpack_public_path__ + "static/media/tail-spin.94de7ed2.svg";